'use strict';

angular.module('AcaApp').controller('HeaderController', [
  '$rootScope',
  '$scope',
  '$location',
  'AuthenticationService',
  'AUTH_EVENTS',
  '$window',
  'LayoutService',
  'ProfileService',
  '$timeout',
  'NotificationsService',
  '$interval',
  '$mdDialog',
  'UtilsService',
  'SettingsService',
  '$q',
  'ManagedUserInformationService',
  '$route',
  function(
    $rootScope,
    $scope,
    $location,
    AuthenticationService,
    AUTH_EVENTS,
    $window,
    LayoutService,
    ProfileService,
    $timeout,
    NotificationsService,
    $interval,
    mdDialog,
    UtilsService,
    SettingsService,
    $q,
    ManagedUserInformationService,
    $route){
    var urisBeforeMainAccess = [
      '/login',
      '/forgot-password',
      '/create-account',
      '/reset-password',
      '/account-locked',
      '/invalid-session',
      '/cliend-disabled',
      '/add-phone',
      '/send-mfa'
    ];
    LayoutService.addFloatLayer('#trigger-user-options', '#layer-user-options');
    LayoutService.addFloatLayer('#trigger-taxyear-options', '#layer-taxyear-options');
    if($window.localStorage['TaxYears'] !== undefined){
      $scope.taxYears = $window.localStorage['TaxYears'].split(',');
    }
    $rootScope.showAllXmitProgress = false;
    $rootScope.showAllXmitAmount = 0;
    $rootScope.showXmitProgress = false;
    $rootScope.showXmitAmount = 0;
    $rootScope.showStateXmitProgress = false;
    $rootScope.showStateXmitAmount = 0;
    $rootScope.$on(AUTH_EVENTS.LOGINSUCCESS, function(event, loginData){
      if((loginData.MFAEnabled === 'null' && !isAdminProfile(loginData.profiles))){
        loginWithOutMfa(loginData);
      }else{
        if((loginData.MFAEnabled !== 'N' && !isManagedServices(loginData.profiles))){
          AuthenticationService.loginMfa(loginData);
        }else{
          loginWithOutMfa(loginData);
        }
      }
    });

    $rootScope.$on('$routeChangeSuccess',
      function(){
        ProfileService.typeOfUser();
        if(!_.contains(urisBeforeMainAccess, $location.path())){
          checkXmitProgress();
        }
        $timeout(function(){
          var menuId = $location.path().replace(/\//, '#');
          var existMenu = $(menuId).length === 1;
          $('.menu-options li').removeClass('selected');
          if(existMenu){
            $(menuId).addClass('selected');
          }
        });
      }
    );

    $scope.checkMangedServicesAndNotSovosProfile = function(){
      return ManagedUserInformationService.isManagedServicesAndNotSovosProfile();
    };

    $scope.getUserId = function(){
      return $window.sessionStorage.userId;
    };

    $scope.getCid = function(){
      return $window.sessionStorage.cid;
    };

    $scope.getRealName = function(){
      return $window.sessionStorage.realName;
    };

    $scope.getTaxYear = function(){
      return $window.sessionStorage.taxYear || '2015';
    };

    $scope.setCurrentTaxYear = function(taxYear){
      $q.all([SettingsService.changeTaxYear(taxYear), SettingsService.updateTaxYearInJwt(taxYear)]).then(function(values){
        $window.sessionStorage.taxYear = taxYear;
        $window.sessionStorage.token = values[1].result.value;
        $location.path('/');
      }, function(error){
        console.log(error.data);
      });
    };

    $scope.goTo = function(path){
      $location.search({});
      $location.path(path);
      checkRoute(path);
    };

    var checkRoute = function(path){
      var wantedPath = '\/' + path;
      var currentRoute = $route.current.$$route.originalPath;
      if(wantedPath === currentRoute){
        $route.reload()
      }
    }

    $scope.logout = function(){
      $location.search({});
      AuthenticationService.logout();
    };

    $scope.cobrowsing = function(){
      acquireIO.startCoBrowseCodeBox();
    };

    var checkXmitProgress = function(){
      NotificationsService.Notifications().then(
        function(data){
          $rootScope.showAllXmitProgress = (data.result.federalReadyTransmittalsCount + data.result.stateReadyTransmittalsCount > 0);
          $rootScope.showAllXmitAmount = (data.result.federalReadyTransmittalsCount + data.result.stateReadyTransmittalsCount > 0) ? data.result.federalReadyTransmittalsCount + data.result.stateReadyTransmittalsCount : 0;
          $rootScope.showXmitProgress = (data.result.federalReadyTransmittalsCount > 0);
          $rootScope.showXmitAmount = (data.result.federalReadyTransmittalsCount > 0) ? data.result.federalReadyTransmittalsCount : 0;
          $rootScope.showStateXmitProgress = (data.result.stateReadyTransmittalsCount > 0);
          $rootScope.showStateXmitAmount = (data.result.stateReadyTransmittalsCount > 0) ? data.result.stateReadyTransmittalsCount : 0;
        },
        function(error){
          console.log('Error: ' + error);
        }
      );
    };
    var isManagedServices = function(profiles){
      return profiles.some(function(profile){
        return profile.ProfileName === 'CNV_ACASOVOS';
      });
    };
    var isAdminProfile = function(profiles){
      return profiles.some(function(profile){
        return profile.ProfileName === 'CNV_ACAADMIN';
      });
    };
    var loginWithOutMfa = function(loginData){
      AuthenticationService.loginSuccess(loginData);
      SettingsService.getTaxYears().then(function(data){
        $window.localStorage['TaxYears'] = data.result.value;
        $window.localStorage['FirstTimeTaxYears'] = true;
        $scope.taxYears = $window.localStorage['TaxYears'].split(',');
      });
    }
  }
]);
